import FieldGroupSearch from './fieldGroupSearch';
import type { FieldGroupSearchProps } from './interface';

export type { FieldGroupSearchProps, };

export default FieldGroupSearch;
